<!-- Font family -->
<div class="field-block">
    <div class="field-head">
        <label class="field-label">Font family</label>
        <span class="axis-badge" [class.overridden]="isOverridden">
            {{ isOverridden ? 'Overridden' : parentLabel }}
        </span>
        <button *ngIf="isOverridden" type="button" class="axis-reset"
                matTooltip="Reset to inherit" (click)="reset()">
            <mat-icon class="material-symbols-outlined">undo</mat-icon>
        </button>
    </div>
    <mat-form-field appearance="outline" class="full-width">
        <mat-select [value]="familyEffective" (selectionChange)="setFamily($event.value)" placeholder="Select a font">
            <mat-option>
                <ngx-mat-select-search [formControl]="fontFilterControl"
                    placeholderLabel="Search fonts…" noEntriesFoundLabel="No fonts found">
                </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let font of filteredFonts$ | async" [value]="font" [style.fontFamily]="font">
                {{ font }}
            </mat-option>
        </mat-select>
    </mat-form-field>
</div>
